import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { OccurrenceNoteModelLike } from 'app/shared/models/occurrence.model';

interface NoteForm {
  text: FormControl<string>;
}

@Component({
  selector: 'app-note-form',
  templateUrl: 'note-form.component.html',
  styleUrls: ['note-form.component.scss'],
})
export class NoteFormComponent implements OnChanges, OnDestroy {
  @Input()
  visible: boolean;
  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Input()
  model: OccurrenceNoteModelLike;

  @Output()
  onSaveChanges = new EventEmitter<Partial<OccurrenceNoteModelLike>>();

  formGroup: FormGroup<NoteForm>;

  private lifecycle = new Subject<void>();

  constructor(private formBuilder: FormBuilder) {
    this.formGroup = this.formBuilder.group({
      text: this.formBuilder.control<string>(null, [Validators.required]),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model && this.visible) {
      this.formGroup.reset(this.model ?? {});
    }
  }

  ngOnDestroy(): void {
    this.lifecycle.next();
    this.lifecycle.complete();
  }

  onShowingInternal() {
    if (this.model) {
      this.formGroup.reset(this.model);
    }
  }

  onHiddenInternal() {
    this.formGroup.reset();
  }

  onSubmit(e) {
    e?.preventDefault();

    const changes = this.formGroup.getRawValue();
    this.onSaveChanges.emit(changes);

    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onBtnCancelClick() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
